document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.yc-mobile-toggle');
  const nav = document.getElementById('YCMobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  document.querySelectorAll('.yc-product-form').forEach(function(form){
    form.addEventListener('submit', function(){
      const button = form.querySelector('button[type="submit"]');
      if (button && !button.disabled) {
        button.dataset.originalText = button.textContent;
        button.textContent = 'Adding…';
        setTimeout(function(){ button.textContent = button.dataset.originalText || 'Add to cart'; }, 1800);
      }
    });
  });
});